<div mat-dialog-title>
  <div class="modal__header">
    <div class="modal__title">
      <h1 *ngIf="!isExcelStep">{{ data.title }}</h1>
      <h1 *ngIf="isExcelStep">Export as Excel Output</h1>
    </div>
    <div class="mt-2 w-450">
      <span *ngIf="!isExcelStep">{{ data.body }}</span>
      <span *ngIf="isExcelStep">
        Please select which excel document file you want to Output for {{ 'sow|l' | lang }}
      </span>
    </div>
    <button
      class="close-button"
      mat-dialog-close>
      <i class="material-symbols-rounded">close</i>
    </button>
  </div>
</div>

<mat-dialog-actions class="export-scope-actions">
  <div *ngIf="!isExcelStep">
    <button
      has-privilege="SCOPE__EXPORT_DOCX"
      (click)="exportToWordDoc()"
      class="export-scope-button">
      <span class="export-scope-circle">W</span>
      <span class="export-scope-type">Export as Word Document</span>
    </button>

    <button
      has-privilege="SCOPE__EXPORT_XLSX"
      (click)="isExcelStep = true"
      class="export-scope-button">
      <span class="export-scope-circle">X</span>
      <span class="export-scope-type">Export as Excel Document</span>
    </button>
  </div>

  <div
    *ngIf="isExcelStep"
    has-privilege="SCOPE__EXPORT_XLSX">
    <button
      (click)="exportToExcel(ExcelOutputType.EXCEL)"
      class="export-scope-button">
      <span class="export-scope-circle">X</span>
      <span class="export-scope-type">Export as Excel Document</span>
    </button>

    <button
      (click)="exportToExcel(ExcelOutputType.DEPARTMENT_HOURS)"
      class="export-scope-button">
      <span class="export-scope-circle">X</span>
      <span class="export-scope-type">Hours by department</span>
    </button>
  </div>
</mat-dialog-actions>
